export default __webpack_public_path__ + "static/media/app-homescreen.33c74503.png";